"use strict";

exports.version = "1.5.28";


//////////////////
// WEBPACK FOOTER
// ./~/@dp/owl/lib/constant/version.js
// module id = 74
// module chunks = 0